import React, {useEffect, useState} from 'react';
import Typography from '@mui/material/Typography';
import classNames from './SelectPackage.module.css';
import {Card, CardContent} from '@mui/material';
import {Package as PackageElem} from '../package/client/Package';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTheme} from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import {useQuery} from "@apollo/client";
import {GET_PACKAGES, Package} from "../../api/package/getPackages";

type SelectPackageProps = {
    onSelect: (packageId: string) => void,
    setLoading: (nextState: boolean) => void,
}

export const SelectPackage = (props: SelectPackageProps) => {
    const {onSelect, setLoading} = props

    const [selectedPackage, setSelectedPackage] = useState<Package>()
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [packages, setPackages] = useState<Package[]>([])

    const {loading, data} = useQuery(GET_PACKAGES);

    useEffect(() => {
        setLoading(loading)
    }, [loading])

    useEffect(() => {
        if (data !== undefined) {
            setPackages([...data.allPackages].sort(
                (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
            ))
        }
    }, [data])

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant="h6">Select the package that suits you best</Typography>

                    <div className={classNames.packagesContainer}>
                        {
                            packages.map((packageData) => (
                                <PackageElem
                                    key={packageData.id}
                                    description={packageData.description}
                                    name={packageData.title}
                                    onClick={() => {
                                        setSelectedPackage(packageData)
                                        setIsModalOpen(true)
                                    }}
                                    price={packageData.price}
                                />
                            ))
                        }
                    </div>
                </CardContent>
            </Card>

            <Dialog
                fullScreen={fullScreen}
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            >
                <DialogTitle>
                    Confirm Selection
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        You selected the package <strong>{selectedPackage ? selectedPackage.title : ''}</strong>
                    </DialogContentText>
                    <DialogContentText>
                        Please confirm you'd like to proceed.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setIsModalOpen(false)}
                        variant="outlined"
                    >
                        Disagree
                    </Button>
                    <Button
                        onClick={() => onSelect(selectedPackage ? selectedPackage.id : '')}
                        variant="contained"
                    >
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
